import { defineSelectorResultFunction } from '@exodus/redux-dependency-injection';
const resultFunction = (walletAccounts) => (name) => walletAccounts[name];
export default defineSelectorResultFunction({
    id: 'get',
    resultFunction,
    dependencies: [
        { selector: 'data' },
    ],
});
